import BaseViewController from "./base-view-controller";
import { fetchImage } from "../api/photo-upload";
import { downloadFile as downloadFileApi } from "../api/file-download";
import { downloadFile } from "../utils/download-file";

class ImagesListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    if (name === "selectedData") {
      const { member_id, member_attachment_id, display_filename } = text;

      if (text.human_readable_attachment_type === "Photo") {
        const url = `/get_image/large?member_id=${member_id}&member_attachment_id=${member_attachment_id}`;

        fetchImage(url).then(
          data => data && downloadFile(data, display_filename)
        );
      } else {
        downloadFileApi(
          `members/${member_id}/attachments/${member_attachment_id}`,
          text.display_filename
        );
      }
    } else {
      if (action.value === "PhotoModal") {
        this.formState = {
          "__medicalInfo:photoPreview": "",
          "__medicalInfo:photoName": "",
          "__medicalInfo:attachment_type_cd": ""
        };
      }

      if (action.value === "SharedImagesUpload") {
        const maxPhotos = this.appData.values.photo_upload_limit
          ? parseInt(this.appData.values.photo_upload_limit, 10)
          : 3;
        // We need this to clean thumbnails if for some reason member click Add file after submitting the MHN case
        for (let i = 1; i < maxPhotos + 1; i++) {
          if (
            this.appData.values[`__photo${i}:photoPreview`] ||
            this.appData.values[`__photo${i}:photoPreview`]?.uuid
          ) {
            this.appData.values[`__photo${i}:photoPreview`] = "";
            this.appData.values[`__photo${i}:photoName`] = "";
            this.appData.values[`__photo${i}:attachment_type_cd`] = "";
          }
        }

        this.appData.values.attached_images = [];
      }
      super.handleButtonClick(name, text, action);
    }
  }

  preprocessScreenData() {
    const noImagesField = this.screen.fields.find(
      f => f.name === "empty_list_message"
    );
    if (
      this.screen.fields.find(field => field.childrenType === "image-list-item")
    ) {
      noImagesField.params += "|TDFieldOptionIgnore";
    } else {
      noImagesField.params = noImagesField.params.replace(
        "|TDFieldOptionIgnore",
        ""
      );
    }
    super.preprocessScreenData();
  }
}

export default ImagesListViewController;
